import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MatCardModule } from '@angular/material/card';

import { AppConfigService, CommonModule as DexioCommonModule, ViewerModule } from '@dexio/common';

import { environment } from '../environments/environment';

// import { loadProjectModules } from './utils/routes';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LoraxModule } from './modules/lorax/lorax.module';
import { HomePageComponent } from './pages/home/home-page.component';
import { ReportsModule } from './modules/reports/reports.module';
import { RoutesService } from './services/routes.service';
import { AgGridModule } from '@ag-grid-community/angular';
import { SearchPageComponent } from './pages/search/search-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminModule } from './modules/admin/admin.module';
import { LoaderComponent } from './components/loader/loader.component';
import { ProjectsService } from './services/projects.service';

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    SearchPageComponent,
    LoaderComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    DexioCommonModule.forRoot(environment.configurationUrl),
    ViewerModule,
    LoraxModule,
    ReportsModule,
    MatCardModule,
    AgGridModule,
    AdminModule
  ],
  bootstrap: [AppComponent],
  providers: [
    provideAnimationsAsync(),
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: (router: Router) => () => loadProjectModules(router),
    //   deps: [ Router ],
    //   multi: true
    // },
    RoutesService
  ]
})
export class AppModule { }

